import React from "react";
import { useElementObserveSize } from "./useElementObserveSize.js";
export function useElementSize(ref) {
    const [size, setSize] = React.useState({ width: 0, height: 0 });
    useElementObserveSize(ref, setSize);
    return size;
}
//# sourceMappingURL=useElementSize.js.map